// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-6c08aa4a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 36px;\n  width: 100%;\n  display: block;\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  background: none;\n  font-size: var(--main-font-size);\n  color: #666666;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
